import { render, staticRenderFns } from "./InvestorProfileDropDown.vue?vue&type=template&id=cf890b9c&"
import script from "./InvestorProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./InvestorProfileDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports